import { StateCreator } from "zustand";
import { CustomDialogProps } from "@mirage/contracts/CustomDialogProps";

export interface ConfirmDialogProps extends CustomDialogProps {
    onReject?: () => void;
    onConfirm?: () => void;
    onConfirmColor?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
    onConfirmLabel?: string;
    onRejectLabel?: string;
    onConfirmDisabled?: boolean;
    fullWidth?: boolean;
}

export interface ConfirmDialogSlice {
    confirmDialog: ConfirmDialogProps;
    setConfirmDialog: (state: ConfirmDialogProps) => void;
    updateConfirmDialog: (partialState: Partial<ConfirmDialogProps>) => void;
    resetConfirmDialog: () => void;
}

const initialConfirmDialogState: ConfirmDialogProps = { open: false, mutation: "" };

export const createConfirmDialogSlice: StateCreator<ConfirmDialogSlice, [], [], ConfirmDialogSlice> = (set) => ({
    confirmDialog: initialConfirmDialogState,

    setConfirmDialog: (state) => set({ confirmDialog: state }),
    updateConfirmDialog: (partialState) => set((state) => ({ confirmDialog: { ...state.confirmDialog, ...partialState } })),
    resetConfirmDialog: () => set({ confirmDialog: initialConfirmDialogState }),
});
